










































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { Lane } from '@/models/admin/lane';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import {getHeaders, getLaneHeaders } from '@/views/admin/lane/lane';
import {laneService} from '@/shared';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        Stores: () => import('@/components/common/store.select.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
})
export default class LaneListPage extends Base {
    public headers: VHeaders[] = getHeaders(this);
    public laneHeaders: VHeaders[] = getLaneHeaders(this);
    public pagedLanes: Lane[] = [];
    public laneConnectionStatuses: any[] = [];
    public pagination = new PaginationModel('name');
    public lanePagination = new PaginationModel('timeStamp', true, 5);
    public loading: boolean = false;
    public laneLoading: boolean = false;
    public isLaneConnectionHistoryVisible: IDialogOption = {
        width: 600,
        title: this.$parent.$t('lanes.laneConnectionHistoryDialogTitle') as string,
        model: false,
    };
    public storeId: number;
    public actions: any[] = [];
    public deleteDialog: IDialogOption = {
        width: 400,
        title: this.$parent.$t('lanes.deleteDialogTitle') as string,
        model: false,
        action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
        loading: false,
        onAction: (): void => {
            this.deleteLane();
        },
    };
    public laneToDelete: Lane = {
        laneId: 0,
        terminalId: '',
        serialNumber: '',
        description: '',
        activationCode: '',
        marketCode: 0,
        isActivated: false,
        storeDealershipName: '',
        paymentAccountType: '',
    };
    public preventPaginationCall: boolean = false;

    public setActions() {
        this.actions = [{
            type: 'button',
            icon: 'fa fa-signal',
            title: this.$t('lanes.laneGridHeaders.gridAction.checkConnectionHistory') as string,
            action: (model: Lane, storeId: string) => {
                this.checkConnectionHistory(model);
            },
        }
            , {
            type: 'button',
            icon: 'fas fa-trash-alt',
            title: this.$t('lanes.laneGridHeaders.gridAction.delete') as string,
            color: 'error',
            action: (model: Lane, storeId: string) => { this.confirmDelete(model); },
        },
        ];
    }
    public created() {
        this.storeId = this.userSession.storeId;
    }

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'addLane') {
            this.$router.push({ name: 'admin.lanes.add', params: { storeId: this.storeId.toString() } });
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$t('lanes.btnAddLane'), disabled: false, visible: true, class: 'btn', label: this.$t('lanes.btnAddLane'), click: 'addLane', icon: 'fas fa-plus-circle' });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'lanes');

        if (this.$route.params.storeId) {
            this.storeId = Number(this.$route.params.storeId);
        }
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
        if (!this.isAuthorizedToAccess(['SuperAdmin', 'T-Admin', 'E-Admin'])) {
            this.getLanes();
        }
        this.setActions();
    }
    public async getLanes(): Promise<void> {
        try {
            this.loading = true;
            const lanes = await laneService.getAllAsync(this.storeId, this.pagination);
            this.pagedLanes = lanes.results;
            this.pagination.totalItems = lanes.total;
        } finally {
            this.loading = false;
        }
    }
    public updatePaging(paging: any) {
        this.pagination = paging;
    }
    public updateLanePaging(paging: any) {
        this.lanePagination = paging;
    }
    public confirmDelete(item: Lane): void {
        this.deleteDialog.model = true;
        this.laneToDelete = item;
    }
    public async checkConnection(item: Lane): Promise<void> {
        const status = await laneService.getStatusAsync(item.laneId, this.storeId);
        this.showAlert(true, status.status);
    }
    public async checkConnectionHistory(item: Lane): Promise<void> {
        try {
            this.laneLoading = true;
            this.isLaneConnectionHistoryVisible.model = true;
            const connectionHistory = await laneService
                .getConnectionHistoryAsync(item.laneId, this.storeId);
            this.laneConnectionStatuses = connectionHistory.results;
            this.lanePagination.totalItems = connectionHistory.total;
        } catch {
            this.isLaneConnectionHistoryVisible.model = false;
        } finally {
            this.laneLoading = false;
        }
    }

    public async deleteLane(): Promise<void> {
        try {
            this.deleteDialog.loading = true;
            await laneService.deleteAsync(this.laneToDelete.laneId, this.storeId);
            this.preventPaginationCall = true;
            this.showAlert(true, this.$t('lanes.alertDeleteLane'));
            this.getLanes();
        } catch (e) {
            console.log(e);
        } finally {
            this.deleteDialog.loading = false;
            this.deleteDialog.model = false;
        }

    }
    public updateStore(storeId: number): void {
        this.storeId = storeId;
        this.getLanes();
    }
}
